<h2>
  {{ config.title }}
  <!-- <mat-icon fontSet="material-symbols-outlined">touch_app</mat-icon> -->
</h2>

<div class="chart-wrapper">
  <canvas
    baseChart
    [type]="chartType"
    [data]="chartData"
    [options]="chartOptions"
    [plugins]="chartPlugins"
  ></canvas>
</div>
